module.exports = "/_next/static/images/apple-icon-72x72-56412c22acaed638c44e5a71500031db.png";